(() => {
  const bind = (root = document) => {
    root.querySelectorAll('[data-pixel-product]').forEach(section => {
      if (section.dataset.pixelPurchaseBound) return;
      const form = section.querySelector('form.pixel-product-form');
      if (!form) return;
      section.dataset.pixelPurchaseBound = 'true';
      const select = form.querySelector('[data-pixel-variant]');
      const compare = section.querySelector('[data-pixel-compare-price]');
      const saving = section.querySelector('[data-pixel-saving]');
      const updatePrice = () => {
        const option = select?.selectedOptions[0];
        if (!option) return;
        if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !option.dataset.comparePrice; }
        if (saving) { saving.textContent = option.dataset.saving || ''; saving.hidden = !option.dataset.saving; }
      };
      select?.addEventListener('change', updatePrice);
      updatePrice();
      const quantity = form.querySelector('[data-pixel-quantity]');
      const steps = [...form.querySelectorAll('[data-pixel-quantity-step]')];
      const updateQuantity = () => {
        if (!quantity) return;
        steps.forEach(button => { button.disabled = Number(button.dataset.pixelQuantityStep) < 0 ? Number(quantity.value) <= Number(quantity.min || 1) : Boolean(quantity.max) && Number(quantity.value) >= Number(quantity.max); });
      };
      steps.forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (Number(button.dataset.pixelQuantityStep) < 0) quantity.stepDown();
          else quantity.stepUp();
          quantity.dispatchEvent(new Event('input', { bubbles: true }));
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
          updateQuantity();
        });
      });
      quantity?.addEventListener('input', updateQuantity);
      select?.addEventListener('change', updateQuantity);
      updateQuantity();
      const groups = section.querySelector('[data-pixel-option-groups]');
      // Existing commerce must own the enabled native selector before enhancing it.
      if (!groups || !select || select.disabled) return;
      let variants;
      try {
        variants = [...select.options].map(option => ({ option, values: JSON.parse(option.dataset.pixelOptions).map(value => typeof value === 'string' ? value : value.name), available: option.dataset.available === 'true' }));
      } catch (error) {
        console.warn('Pixel option controls retained their native fallback:', error.message);
        return;
      }
      const fields = [...groups.querySelectorAll('[data-pixel-option-group]')];
      if (!variants.length || variants.some(variant => variant.values.length !== fields.length)) return;
      const selectedVariant = () => variants.find(variant => variant.option.value === select.value);
      const matches = (variant, values) => values.every((value, index) => variant.values[index] === value);
      const refresh = () => {
        const current = selectedVariant();
        if (!current) return;
        fields.forEach((field, index) => {
          field.querySelectorAll('[data-pixel-option-value]').forEach(button => {
            const prefix = [...current.values.slice(0, index), button.dataset.pixelOptionValue];
            const candidates = variants.filter(variant => matches(variant, prefix));
            const selected = current.values[index] === button.dataset.pixelOptionValue;
            const available = candidates.some(variant => variant.available);
            button.setAttribute('aria-pressed', String(selected));
            button.disabled = !available;
            const status = button.querySelector('[data-pixel-option-state]');
            if (status) status.hidden = available;
            button.setAttribute('aria-label', `${button.querySelector('[data-pixel-option-label]').textContent.trim()}${available ? '' : ' — unavailable'}`);
          });
        });
      };
      fields.forEach((field, index) => {
        field.querySelectorAll('[data-pixel-option-value]').forEach(button => button.addEventListener('click', () => {
          const current = selectedVariant();
          if (!current || button.disabled) return;
          const prefix = [...current.values.slice(0, index), button.dataset.pixelOptionValue];
          const candidates = variants.filter(variant => variant.available && matches(variant, prefix));
          const preferred = candidates.find(variant => variant.values.slice(index + 1).every((value, offset) => value === current.values[index + 1 + offset])) || candidates[0];
          if (!preferred) return;
          select.value = preferred.option.value;
          // All cart IDs, images, quantity limits and metadata remain owned by native commerce.
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }));
      });
      select.addEventListener('change', refresh);
      refresh();
      groups.hidden = false;
      select.hidden = true;
      form.querySelector('.pixel-native-variant-label')?.setAttribute('hidden', '');
      section.classList.add('pixel-purchase-active');
    });
  };
  const schedule = scope => requestAnimationFrame(() => bind(scope));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => schedule(document));
  else schedule(document);
  document.addEventListener('shopify:section:load', event => schedule(event.target));
})();
